module.exports = __webpack_public_path__ + "media/assets/about_us_bg-abd60a1d04526d169bb370e571a68177.jpg";